import { render, staticRenderFns } from "./VueAutocomplete.vue?vue&type=template&id=bad94660&"
import script from "./VueAutocomplete.vue?vue&type=script&lang=js&"
export * from "./VueAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./VueAutocomplete.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports